module.exports = __webpack_public_path__ + "static/media/corporate-services-img46.e09ed206.jpg";